// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1GS5r","dragIcon":"SortableItem_dragIcon__2dgl5","disabled":"SortableItem_disabled__3tDBT"};